import {
  BasketManagerInfo,
  BasketSlim,
} from 'graphql-api/baskets-api-interfaces';

export function basketManagerInfoToBasketSlim(
  baskets: BasketManagerInfo[],
): BasketSlim[] {
  if (!baskets) return [];

  return baskets.map(
    (basket): BasketSlim => ({
      id: basket.basketId,
      basketAccounts: basket.basketAccounts,
      createdTime: basket.creationTime,
      orderReferenceNumber: basket.orderReferenceNumber,
      clientReferenceNumber: basket.clientReferenceNumber,
      status: basket.status,
      totalQuantity: basket.summary?.totalPiecesQuantity as number,
      totalValueByCurrency: basket.summary?.totalValueByCurrency,
      netTotalValueByCurrency: basket.summary?.totalValueByCurrency,
    }),
  );
}
